{
  "dropzoneLabel": "DropZone",
  "selectPlaceholder": "Válasszon ki egy elemet",
  "tableResizer": "Átméretező",
  "colorSwatchPicker": "Color swatches"
}
